/**
 * An editor's primary button. A new record can always be submitted; an
 * existing one only once something has changed. Right after a save it also
 * carries a "Saved" tick, which the stylesheet shows below desktop width.
 */
import { Check } from 'lucide-react';

import './editor-page.css';

export interface EditorSaveButtonProps {
  /** Lower case, e.g. "campaign": the button reads "Create campaign" on desktop. */
  noun: string;
  isNew: boolean;
  dirty: boolean;
  saving: boolean;
  saved: boolean;
  onSave: () => void;
}

export function EditorSaveButton(p: EditorSaveButtonProps) {
  const disabled = p.saving || (!p.isNew && !p.dirty);
  return (
    <button
      type="button"
      className="nb-btn nb-btn-primary nb-ed-save"
      data-saved={p.saved}
      onClick={p.onSave}
      disabled={disabled}
      style={disabled ? { opacity: 0.45, cursor: 'not-allowed' } : undefined}
    >
      <span className="nb-ed-save-idle">
        {p.saving ? (
          p.isNew ? (
            'Creating…'
          ) : (
            'Saving…'
          )
        ) : (
          <>
            {p.isNew ? 'Create' : 'Save'}
            <span className="nb-ed-wide-only">{p.isNew ? ` ${p.noun}` : ' changes'}</span>
          </>
        )}
      </span>
      {p.saved && (
        <span className="nb-ed-save-done">
          <Check size={14} aria-hidden />
          Saved
        </span>
      )}
    </button>
  );
}
